export default "__VITE_PUBLIC_ASSET__2fc91fb8__"